export default function isEmptyObject(obj) {
  if (!obj) return true;

  if(Object.keys(obj).length !== 0) return false

  return true;
}
